import { render, staticRenderFns } from "./PoHomeworkEdit.vue?vue&type=template&id=fc35d7c2"
import script from "./PoHomeworkEdit.vue?vue&type=script&lang=js"
export * from "./PoHomeworkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports